import { Grid } from "@mui/material";
import { useFieldArray } from "react-hook-form";
import { useSelector } from "react-redux";
import { AddButton, RemoveButton } from "../../../../../components/buttons";
import { TextInput } from "../../../../../components/inputs";
import { attorneyObject } from "./lpaQuestionnaireFormConstants";

const PeopleToBeToldItem = () => {
  const isJoint = useSelector((state) => state?.instruction?.isJoint);
  const arr = useSelector((state) => state?.instruction?.arr);

  const client1 = useFieldArray({
    name: `InstructionLPA_Questionnaire.[0].peopleData.people`,
  });

  const { append, remove, fields } = client1;

  const client2 = useFieldArray({
    name: `InstructionLPA_Questionnaire.[1].peopleData.people`,
  });

  const {
    append: secondaryAppend,
    remove: secondaryRemove,
    fields: secondaryFields,
  } = client2;

  const handleAdd = (clientNumber, arrayLength) => {
    clientNumber === 0
      ? append(arrayLength === 0 ? attorneyObject : attorneyObject)
      : secondaryAppend(arrayLength === 0 ? attorneyObject : attorneyObject);
  };

  const handleRemove = (clientNumber, ind) => {
    if (clientNumber === 1) {
      remove(ind);
    } else {
      secondaryRemove(ind);
    }
  };
  return (
    <>
      <Grid width={"100%"} display={"flex"} flexDirection={"row"}>
        {arr?.map((item, index) => {
          return (
            <Grid
              width={isJoint ? "50%" : "100%"}
              borderTop={`1px solid #DCDCE1`}
              borderBottom={`1px solid #DCDCE1`}
              borderRight={index === 0 ? `1px solid #DCDCE1` : null}
              paddingY={4}
              display={"flex"}
              flexDirection={"column"}
              gap={3}
              paddingRight={index === 0 ? 2 : 0}
              paddingLeft={index === 1 ? 2 : 0}
            >
              {(index === 0 ? fields : secondaryFields).map((card, ind) => {
                return (
                  <PeopleToBeToldForm
                    key={card.id}
                    isJoint={isJoint}
                    index={index}
                    cardNo={ind}
                    handleRemove={() => handleRemove(item, ind)}
                    pathName={`InstructionLPA_Questionnaire.${index}.peopleData.people.${ind}`}
                  />
                );
              })}
              <Grid textAlign={"center"}>
                <AddButton
                  onClick={() =>
                    handleAdd(
                      index,
                      (item === 1 ? fields : secondaryFields).length
                    )
                  }
                />
              </Grid>
              <TextInput
                label={`Notes`}
                name={`InstructionLPA_Questionnaire.${index}.peopleData.notes`}
                placeholder="Enter note(s)"
              />
            </Grid>
          );
        })}
      </Grid>
    </>
  );
};

export default PeopleToBeToldItem;

const PeopleToBeToldForm = ({ index, cardNo, handleRemove, pathName }) => {
  return (
    <Grid
      boxShadow={"1px 2px 6px #00000029"}
      borderBottom={`1px solid #DCDCE1`}
      borderRadius={"16px"}
      borderRight={index === 0 ? `1px solid #DCDCE1` : null}
      padding={2}
      paddingY={3}
      display={"flex"}
      flexDirection={"column"}
      gap={2}
      position={"relative"}
    >
      <TextInput
        label={`Full Name`}
        name={`${pathName}.fullName`}
        placeholder="Enter name"
      />

      <div style={{ textAlign: "right" }}>
        <RemoveButton label={"Joint"} onClick={handleRemove} />
      </div>
    </Grid>
  );
};
